import { useState } from 'react'
import CalculatorSummary from './CalculatorSummary'

import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerTitle,
} from '@/components/ui/drawer'
import ShareCalculations from './ShareCalculations'
import { MessageCircleQuestion as IconMessageCircleQuestion } from 'lucide-react'
import useOpenIntercomChat from '@/hooks/useOpenIntercomChat'
import { VisuallyHidden } from '@radix-ui/react-visually-hidden'

const snapPoints = ['114px', '340px']

const ScoreDrawer = ({ showImproveGrades }: { showImproveGrades: boolean }) => {
  const [snap, setSnap] = useState<number | string | null>(snapPoints[0])
  const handleOpenIntercomChat = useOpenIntercomChat()

  function handleClick() {
    if (snap === snapPoints[0]) {
      setSnap(snapPoints[1])
    } else {
      setSnap(snapPoints[0])
    }
  }

  return (
    <Drawer
      snapPoints={snapPoints}
      activeSnapPoint={snap}
      setActiveSnapPoint={setSnap}
      snapToSequentialPoint
      defaultOpen={true}
      modal={false}
      dismissible={false}
      data-testid="score-drawer"
    >
      <VisuallyHidden asChild>
        <DrawerTitle>Resultat</DrawerTitle>
      </VisuallyHidden>
      <DrawerContent
        onClick={handleClick}
        className="h-screen h-[100dvh] data-[vaul-drawer-direction=bottom]:max-h-[100vh] data-[vaul-drawer-direction=bottom]:max-h-[100dvh]"
        data-testid="score-drawer-content"
      >
        <VisuallyHidden asChild>
          <DrawerDescription>Se poengene dine</DrawerDescription>
        </VisuallyHidden>
        <CalculatorSummary
          type={showImproveGrades ? 'improved' : 'unimproved'}
        />
        <div className="px-7 py-5 bg-warm-gray-50 rounded-b-xl flex items-center justify-between gap-2 mt-4" data-testid="score-drawer-footer">
          <button
            className="flex items-center gap-2 cursor-pointer hover:text-purple-700 group"
            onClick={handleOpenIntercomChat}
            data-testid="chat-advisor-button"
          >
            <IconMessageCircleQuestion className="size-5 text-warm-gray-700 group-hover:text-inherit" />
            <span className="text-sm font-semibold">Chat med rådgiver</span>
          </button>
          <ShareCalculations />
        </div>
      </DrawerContent>
    </Drawer>
  )
}

export default ScoreDrawer
